import axios from 'axios'

import { getBaseUrl } from 'utils/baseUrls'
import { getNodeEnv, isTestEnvironment } from 'utils/environment'

const GREMLIN_AGENT = `website/${getNodeEnv()}`

const baseURL = `${getBaseUrl('api')}/v1`
const agent = axios.create({
  baseURL,
  adapter: isTestEnvironment() ? 'http' : 'xhr'
})

function bootstrapAgent() {
  agent.interceptors.request.use(function (config) {
    config.headers['X-Gremlin-Agent'] = GREMLIN_AGENT
    return config
  })
}

export { agent, bootstrapAgent }
export default agent
